import { SelectModelModel } from '../../../select/select-model';

export const FONT_WEIGHT_MODEL: SelectModelModel = [
  { value: 'normal', item: <span className="font-normal">Normal</span> },
  { value: 'bold', item: <span className="font-bold">Negrita</span> },
] as const;

export type FontWeight = (typeof FONT_WEIGHT_MODEL)[number]['value'];
